import React, { Component, Fragment } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

class Pagination extends Component {

  _changePage = p => e => this._goToPage(p)
  _goBack = p => e => this._goToPage(p - 1)
  _goNext = p => e => this._goToPage(p + 1)

  _goToPage = this.props.goToPage

  _renderPages = (current_page, num_pages) => {
    const getRange = (start, stop, step) => {
      var a=[start], b=start;
      while(b<stop){b+=(step || 1);a.push(b)}
      return a;
    }

    const max_pages = 10
    const range = getRange(1, num_pages < max_pages ? num_pages : 10, 1)
      .map(i => {
        if(num_pages > 10) {
          if(current_page < 6) {
            return i
          }
          return (-5 + i) + (current_page)
        }
        return i
      }).filter(v => v > 0 && v < num_pages + 1)
    const isActive = (p, current_page) => p === current_page
    return(
      <Fragment>
        {
          range.map(r => (
            <span
              key={r}
              className={`pagination-link ${isActive(r, current_page) ? 'active' : "not-active-page-number"}`}
              onClick={this._changePage.bind(this)(r)}
            >
              {r}
            </span>
          ))
        }
      </Fragment>
    )
  }

  render() {
    const { current, total_pages} = this.props
    if(this.props.total_results === 0) return null
    return (
     
      <div className='pagination-container'>
        <div className='pagination-wrapper'>
          <span
            className={`pagination-link pagination-prev-next ${current > 1 ? 'active' : ""}`}
            onClick={current > 1 ? this._goBack(current) : () => {}}
          >
            <span>
              <FontAwesomeIcon icon='chevron-left' />
              &nbsp;
              Prev
            </span>
          </span>
          {
            this._renderPages(current,  total_pages)
          }
          <span
            className={`pagination-link pagination-prev-next ${!(current ===  total_pages) ? 'active' : ""}`}
            onClick={!(current ===  total_pages) ? this._goNext(current) : () => {}}
          >
            <span>
              Next
              &nbsp;
              <FontAwesomeIcon icon='chevron-right' />
            </span>
          </span>
        </div>
      </div>
    )
  }
}

export default Pagination